var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"stylex":{paddingLeft: '320px'}}},[_c('iframe',{staticStyle:{"position":"absolute","width":"100%","height":"100%","border":"none","margin-top":"64px"},attrs:{"src":"/dashboard"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }